var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"text-2xl bg-EXPONDO-grey-5\n        border-EXPONDO-grey-20 disabled:text-EXPONDO-grey-60",class:{
    'px-0 w-6': _vm.isSmall,
    'px-0 w-12': _vm.isLarge,
    'px-3.5 font-semibold': !_vm.isSmall && !_vm.isLarge,
    'rounded-l-md border-r': _vm.isLeft,
    'rounded-r-md border-l': !_vm.isLeft
  },attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }